import colors from 'basic-ui-lib/constants/colors';
import { IContentItem } from 'modules/channel/interfaces/api';
import styled from 'styled-components';
import { renderMedia } from '../MainZone';

interface ThreePortraitsProps {
  value?: IContentItem[];
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
  gap?: number;
}
const ThreePortraits = ({ value, onSelectZone, activeZone, border, gap }: ThreePortraitsProps) => {
  const listPortraits = ['LEFT', 'MAIN', 'RIGHT'];
  return (
    <ThreePortraitsWrapper $border={border} $gap={gap}>
      {[0, 1, 2].map((index) => (
        <PortraitWrapper key={index} onClick={() => onSelectZone?.(listPortraits[index])} $active={activeZone === listPortraits[index]} $border={border}>
          {renderMedia(value?.find(item => item.zone === listPortraits[index]), border)}
        </PortraitWrapper>
      ))}
    </ThreePortraitsWrapper>
  );
};

export default ThreePortraits;

const ThreePortraitsWrapper = styled.div<{ $border?: number; $gap?: number }>`
  width: 100%;
  height: 100%;
  min-width: 48px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  background-color: ${colors.neutral.text[3]};
  overflow: hidden;
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '1px')};
  padding: 4px;
`;

const PortraitWrapper = styled.div<{$active?: boolean, $border?: number}>`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  background-color: ${colors.neutral.text[2]};
`;
